/**
 * Sanitize user input for safe display in HTML or transmission to backend.
 * Strips all HTML tags (text-only) to prevent XSS when content is rendered in HTML.
 */

import DOMPurify from 'dompurify';

/**
 * Sanitize a string for safe display: strip all HTML tags and encode dangerous chars.
 * Use before sending user input to APIs (e.g. support-escalation) or when
 * rendering in contexts that might be interpreted as HTML.
 */
export function sanitizeForDisplay(text: string): string {
  if (typeof text !== 'string') return '';
  // DOMPurify with no allowed tags returns text-only (tags stripped)
  const sanitized = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
  return sanitized;
}
